import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=4f94fe75"
import script from "./CampaignName.vue?vue&type=script&lang=js"
export * from "./CampaignName.vue?vue&type=script&lang=js"
import style0 from "./CampaignName.vue?vue&type=style&index=0&id=4f94fe75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports